export function isValidDomain(domain: string): boolean {
  return /^(?:(?:(?:[a-zA-z-]+):\/{1,3})?(?:[a-zA-Z0-9])(?:[a-zA-Z0-9\-.]){1,61}(?:\.[a-zA-Z]{2,})+|\[(?:(?:(?:[a-fA-F0-9]){1,4})(?::(?:[a-fA-F0-9]){1,4}){7}|::1|::)\]|(?:(?:[0-9]{1,3})(?:\.[0-9]{1,3}){3}))(?::[0-9]{1,5})?$/.test(
    domain,
  );
}

export const ENOCH_DEFAULT_CONFIG_NAME = 'default';

export const ENOCH_MACHINE_STATE = {
  IDLE: 'IDLE',
  RUNNING: 'RUNNING',
  SCHEDULED: 'SCHEDULED',
  DISCONNECTED: 'DISCONNECTED',
};
